export function getLocalData(param) {
  if (param === 'accessToken') return localStorage.getItem('accessToken')
  if (param === 'address') return localStorage.getItem('address')
  else return localStorage.getItem('accessToken')
}

export function setLocalData(param, value) {
  if (param === 'accessToken') return localStorage.setItem('accessToken',value)
  if (param === 'address') return localStorage.setItem('address',value)
  else return localStorage.setItem('accessToken',value)
}

export function clearLocalData() {
  localStorage.clear()
}